import { Location, LocationFile } from '@/api/documents'
import { Row, Typography } from '@/components'
import { Pagination } from '@/components/molecules/Pagination'
import { DataTable, useDataTable } from '@surein/ui'
import { useMemo, useState } from 'react'
import { useTranslation } from 'react-i18next'
import createColumns from './columns'
import { StyledRelativeContainer, TableContainer } from './styles'

type DocumentsTableProps = { companyId: string; location: Location }

const DocumentsTable = ({ companyId, location }: DocumentsTableProps) => {
  const { t } = useTranslation()

  const columns = useMemo(() => createColumns(t, companyId), [t, companyId])

  const [pagination, setPagination] = useState({
    pageIndex: 0,
    pageSize: 10,
  })

  const table = useDataTable<LocationFile>({
    columns: columns,
    data: location.files,
    configOverrides: {
      state: {
        pagination,
      },
      onPaginationChange: setPagination,
      enableFilters: true,
      enableColumnFilters: true,
      globalFilterFn: 'includesString',
    },
  })

  const pageCount = table.getPageCount()
  const hasData = useMemo(() => location.files.length > 0, [location.files])

  return (
    <TableContainer hasData={hasData}>
      <Row gap="16px" justifyContent="space-between">
        <Typography bold variant="p1Body">
          {location.locationName}
        </Typography>
      </Row>
      <StyledRelativeContainer>
        <DataTable
          table={table}
          borderless
          emptyText={t('documentsPage.table.empty')}
        />
        {hasData && (
          <Pagination
            pageIndex={pagination.pageIndex}
            pageCount={pageCount}
            onPageChange={(index) => table.setPageIndex(index)}
            onPageSizeChange={(size) => table.setPageSize(size)}
          />
        )}
      </StyledRelativeContainer>
    </TableContainer>
  )
}

export default DocumentsTable
